import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	minimize: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	minimizeDisabled: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dock: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dockDisabled: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	fullScreenExit: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	fullScreenExitDisabled: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	expand: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	fullScreen: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	close: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	onboardingSpotlightTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	onboardingSpotlightActionGotIt: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	onboardingSpotlightActionLearnMore: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	onboardingSpotlightDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	onboardingSpotlightTitleIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	headerFallbackTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	minimize: {
		id: 'minimizable-modal.modal-container.modal-header.minimize',
		defaultMessage: 'Minimize',
		description: 'Tooltip for minimizing a modal',
	},
	minimizeDisabled: {
		id: 'minimizable-modal.modal-container.modal-header.minimize-disabled',
		defaultMessage: "Can't minimize this view",
		description: 'Tooltip for minimizing a modal',
	},
	dock: {
		id: 'minimizable-modal.modal-container.modal-header.dock',
		defaultMessage: 'Dock to bottom',
		description: 'Tooltip for docking modal to the bottom in a smaller view',
	},
	dockDisabled: {
		id: 'minimizable-modal.modal-container.modal-header.dock-disabled',
		defaultMessage: "Can't dock this view",
		description: 'Tooltip for minimizing a modal',
	},
	fullScreenExit: {
		id: 'minimizable-modal.modal-container.modal-header.full-screen-exit',
		defaultMessage: 'Exit full screen',
		description: 'Tooltip for docking modal to the bottom in a smaller view',
	},
	fullScreenExitDisabled: {
		id: 'minimizable-modal.modal-container.modal-header.full-screen-exit-disabled',
		defaultMessage: "Can't exit full screen",
		description: 'Tooltip for when minimizing a modal is disabled',
	},
	expand: {
		id: 'minimizable-modal.modal-container.modal-header.expand',
		defaultMessage: 'Expand',
		description: 'Tooltip for expanding a modal',
	},
	fullScreen: {
		id: 'minimizable-modal.modal-container.modal-header.full-screen',
		defaultMessage: 'Go full screen',
		description: 'Tooltip for expanding a modal',
	},
	close: {
		id: 'minimizable-modal.modal-container.modal-header.close',
		defaultMessage: 'Close',
		description: 'Tooltip for closing a modal',
	},
	onboardingSpotlightTitle: {
		id: 'minimizable-modal.modal-container.modal-header.onboarding-spotlight-title',
		defaultMessage: 'Welcome to the new issue create experience',
		description:
			'Title for the onborading spotlight to notify user that he is on the new experience',
	},
	onboardingSpotlightActionGotIt: {
		id: 'minimizable-modal.modal-container.modal-header.onboarding-spotlight-action-got-it',
		defaultMessage: 'Got it',
		description: 'Text for CTA action that dismisses the onboarding spotlight',
	},
	onboardingSpotlightActionLearnMore: {
		id: 'minimizable-modal.modal-container.modal-header.onboarding-spotlight-action-learn-more',
		defaultMessage: 'Learn more',
		description: 'Link text that will open the page to know more about the new global issue create',
	},
	onboardingSpotlightDescription: {
		id: 'minimizable-modal.modal-container.modal-header.onboarding-spotlight-description',
		defaultMessage: 'A consistent, fast, and optimized way to capture work in your project.',
		description: 'Description for the onboarding spotlight',
	},
	onboardingSpotlightTitleIssueTermRefresh: {
		id: 'minimizable-modal.modal-container.modal-header.onboarding-spotlight-title-issue-term-refresh',
		defaultMessage: 'Welcome to the new create experience',
		description:
			'Title for the onborading spotlight to notify user that he is on the new experience',
	},
	headerFallbackTitle: {
		id: 'minimizable-modal.modal-container.modal-header.title',
		defaultMessage: 'Create New Work Item',
		description: 'Title for the create issue dialog',
	},
});
export default messages;
